<script>
import ComponentFooter from "@/views/components/ComponentFooter";
import { getBanners } from "@/services/banner.service";

export default {
  name: "LayoutAdmin",
  components: { ComponentFooter },

  data() {
    return {
      banner: null
    };
  },

  computed: {
    lang() {
      return this.$route.fullPath.indexOf("/en/") !== -1 ? "en" : "fr";
    },
    langToggled() {
      return this.lang === "fr" ? "en" : "fr";
    }
  },

  watch: {
    lang() {
      this.loadBanner();
    }
  },

  async created() {
    await this.loadBanner();
  },

  methods: {
    async loadBanner() {
      try {
        const banners = await getBanners();

        if (!Array.isArray(banners)) {
          this.banner = null;

          return;
        }

        const firstActiveBanner =
          banners.find(item => item.isBannerEnabled) ?? null;

        this.banner = firstActiveBanner;
      } catch (err) {
        console.error("Failed to load banners:", err);
        this.banner = null;
      }
    },

    btnToggleLanguageClick() {
      const pathToggled = this.$route.fullPath.replace(
        "/" + this.lang + "/",
        "/" + this.langToggled + "/"
      );

      this.trackEvent(
        "menu",
        "btnToggleLanguageClick",
        "language",
        this.langToggled
      );
      this.$router.push(pathToggled);
    }
  }
};
</script>

<template>
  <div class="grid-layout">
    <div id="header">
      <div id="header1" class="no-print">
        <router-link to="/">
          <img src="@/assets/images/vanfax-sm.png" alt="Vanfax" />
        </router-link>
      </div>
      <div id="header2" class="no-print">
        <div>
          <img src="@/assets/images/vanfax.png" alt="Vanfax" />
          <p>{{ $t("r_header_qsv") }}</p>
        </div>
      </div>
    </div>

    <div v-if="banner" class="banner-wrapper" role="status" aria-live="polite">
      <span class="banner-icon" aria-hidden="true">
        <svg
          viewBox="0 0 24 24"
          width="18"
          height="18"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1 21h22L12 2 1 21z" />
          <rect x="11" y="9" width="2" height="6" fill="#fff" />
          <rect x="11" y="17" width="2" height="2" fill="#fff" />
        </svg>
      </span>
      <span class="banner-text">
        {{ banner.message[lang] }}
      </span>
    </div>

    <div id="content">
      <div id="menu" class="no-print">
        <slot name="slot-menu" />
        <ul>
          <li>
            <a
              class="language no-select"
              :lang="langToggled"
              @click="btnToggleLanguageClick"
            >
              {{ $t("r_page_language_code_toggled") }}
            </a>
          </li>
        </ul>
      </div>
      <div id="main">
        <div id="main-content">
          <slot name="slot-main" />
        </div>
      </div>
    </div>
    <div id="footer" class="no-print">
      <component-footer />
    </div>
  </div>
</template>

<style scoped>
.banner-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  background: #ef000d1a;
  color: #ee020e;
  font-weight: bold;
  font-size: 16px;
  padding: 12px 0;
  line-height: 24px;
}

.banner-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
